import L from "leaflet";

import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import "../styles/controls.css";

import "../extensions/L.Control.MapCenterCoord.min.js";
import "../extensions/L.Control.MapCenterCoord.min.css";
import "../extensions/leaflet.scalefactor";
import "../extensions/leaflet.scalefactor.css";

import { eventBus } from "@/main";
import { GeoUtils } from "@/utils/geo-utils";

// Класс для работы с картой Leaflet без канваса
export class MyLeaf {
  lastZoom = 0;
  isInitialized = false;

  async init(el, url, center, zoom, minZoom = 2, maxZoom = 20) {
    let southWest = L.latLng(-85, -540.0),
      northEast = L.latLng(85, 540.0),
      mybounds = L.latLngBounds(southWest, northEast);

    // Создаем карту асинхронно - разбиваем на части для предотвращения блокировки UI
    await new Promise(resolve => {
      setTimeout(() => {
        this.map = new L.map(el, {
          zoomControl: false,
          preferCanvas: false,
          scrollWheelZoom: "center",
          maxBounds: mybounds,
        }).setView(center, zoom);
        resolve();
      }, 10); // Даем браузеру возможность обновить UI
    });

    // Добавляем контролы асинхронно
    await new Promise(resolve => {
      setTimeout(() => {
        L.control
          .mapCenterCoord({ position: "bottomright", latlngFormat: "DD" })
          .addTo(this.map);

        L.control.scalefactor({ position: "bottomright" }).addTo(this.map);

        this.currentMapsURL = url;

        L.control
          .mapCenterCoord({ latlngFormat: "DM", latlngDesignators: true })
          .addTo(this.map);
        
        resolve();
      }, 5);
    });

    // Добавляем главный слой тайлов асинхронно 
    await new Promise(resolve => {
      setTimeout(() => {
        this.mainLayer = L.tileLayer(this.currentMapsURL, {
          minZoom: minZoom,
          maxZoom: maxZoom,
          maxBounds: mybounds,
          attribution:
            "\"Map data &copy; <a href='http://probki.net/b2b'>Geophone OY</a>",
        }).addTo(this.map);

        L.control
          .zoom({
            position: "bottomright",
          })
          .addTo(this.map);
        
        resolve();
      }, 5);
    });

    let leafletItems = document.getElementsByClassName(
      "leaflet-control-attribution"
    );
    leafletItems.forEach((item) => {
      item.style.display = "none";
    });

    this.map.on("moveend", () => {
      this.controlTooltips();
    });

    this.map.on("zoomend", () => {
      this.controlTooltips();
    });

    this.map.on("drag", () => {
      eventBus.$emit("map-drag");
    });

    this.map.on("dragend", (event) => {
      let coordinates = this.map.getCenter();
      let offset = 0;
      while (coordinates.lng >= 180) {
        coordinates.lng -= 360;
        offset -= 360;
      }

      while (coordinates.lng < -180) {
        coordinates.lng += 360;
        offset += 360;
      }
      eventBus.$emit("map-drag-offset", offset);

      this.map.setView(coordinates, this.map.getZoom(), { animate: false });
    });

    this.map.setMaxBounds(mybounds);
    
    // Помечаем что инициализация завершена
    this.isInitialized = true;
    
    return this.map;
  }

  setTooltipsState(isPermanent) {
    // TODO: this is a hack: expecting to see GeoUtils.defaultOffsets.length visible tooltips
    // For some reasons, new toolip is permanent, but still dissaears when loose focus
    // during WP move operations
    const visibleTooltipsCount = {};
    [...document.getElementsByClassName("leaflet-tooltip")]
      .map((i) => i.innerText)
      .forEach((tt) => {
        visibleTooltipsCount[tt] = (visibleTooltipsCount[tt] ?? 0) + 1;
      });

    this.map.eachLayer((l) => {
      if (l.getTooltip) {
        let toolTip = l.getTooltip();
        if (toolTip && toolTip._content) {
          if (toolTip._content.startsWith("WP")) {
            const latLng = l.getLatLng();
            if (this.isPointOnScreen(latLng)) {
              const visibleCount = visibleTooltipsCount[toolTip._content] ?? 0;

              if (
                isPermanent &&
                visibleCount != GeoUtils.defaultOffsets.length
              ) {
                l.unbindTooltip().bindTooltip(toolTip, {
                  permanent: isPermanent,
                });
              } else if (toolTip.options.permanent != isPermanent) {
                l.unbindTooltip().bindTooltip(toolTip, {
                  permanent: isPermanent,
                });
              }
            } else if (toolTip.options.permanent) {
              l.unbindTooltip().bindTooltip(toolTip, {
                permanent: false,
              });
            }
          }
        }
      }
    });
  }
  // Инициализация тултипов на карте

  // same zoom level is used for both scenarios
  // otherwize tooltips behavioud is not consistent for init and update cases

  tooltipThreshold = 12;

  initTooltips() {
    let zoom = this.map.getZoom();
    let tooltipThreshold = this.tooltipThreshold;
    this.setTooltipsState(zoom >= tooltipThreshold);
    this.lastZoom = zoom;
  }

  // Управление видимостью тултипов в зависимости от зума
  controlTooltips() {
    let zoom = this.map.getZoom();
    let tooltipThreshold = this.tooltipThreshold;
    this.setTooltipsState(zoom >= tooltipThreshold);
    this.lastZoom = zoom;
  }

  moveTo(lat, lon) {
    this.map.setView([lat, lon]);
  }

  panToZone(bounds) {
    this.map.fitBounds(bounds);
  }

  redrawMap(URL, coordinates, zoom_level) {
    this.mainLayer.remove();
    this.map.setView(coordinates, zoom_level);
    this.mainLayer = L.tileLayer(URL);
    this.mainLayer.addTo(this.map);
  }

  isPointOnScreen(pt) {
    const latLng = GeoUtils.toLatLng(pt);
    const bounds = this.map.getBounds();
    const zone = {
      north: bounds.getNorthEast().lat,
      south: bounds.getSouthWest().lat,
      west: bounds.getSouthWest().lng,
      east: bounds.getNorthEast().lng,
    };

    return GeoUtils.isPointInsideZone(latLng, [zone]);
  }
}
